'use client';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface LinkPreviewSkeletonProperties {
  className?: string;
  showMedia?: boolean;
}

export function LinkPreviewSkeleton({ className, showMedia = true }: LinkPreviewSkeletonProperties) {
  return (
    <div className={cn('mt-3 rounded-2xl border border-border/60 bg-card/95 p-5 sm:p-6', className)} aria-busy>
      {showMedia ? <Skeleton className="mb-4 h-32 w-full rounded-xl" /> : null}
      <div className="flex items-center gap-3 mb-4">
        <Skeleton className="h-5 w-5 rounded-sm" />
        <Skeleton className="h-3 w-24" />
      </div>
      <Skeleton className="mb-2 h-5 w-3/4" />
      <Skeleton className="mb-2 h-4 w-full" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  );
}
